module.exports = __webpack_public_path__ + "img/banner_left.1a025e1e.png";